export const ArrowRightSvg = () => {
  return (
    <svg width="7" height="13" viewBox="0 0 7 13" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1 1L6 6.5L1 12" stroke="white" strokeWidth="1.2" />
    </svg>
  )
}
